import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

/**
 * Type-safe way of looking up an item in an array by index
 * @param arr - The target array
 * @param index - The index to fetch
 */
var lookup = function lookup(arr, index) {
  return arr[index];
};

/**
 * Basic comparator function comparing numeric / ASCII values
 * @param a - Left value
 * @param b - Right value
 */
var defaultSortComparator = function defaultSortComparator(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

/**
 * Native immutable string array push
 * @param arr - The target array
 * @param value - Value to add
 */
var arrayPush = function arrayPush(arr, value) {
  return [].concat(_toConsumableArray(arr), [value]);
};

/**
 * Native immutable string array delete
 * @param arr - The target array
 * @param value - Value to remove
 */
var arrayDelete = function arrayDelete(arr, value) {
  var index = arr.indexOf(value);
  return arr.slice(0, index).concat(arr.slice(index + 1));
};
var chunk = function chunk(array, chunkSize) {
  if (chunkSize <= 0) {
    throw RangeError('Chunk size must be greater than 0');
  }
  var result = [];
  for (var i = 0; i < array.length; i += chunkSize) {
    var _chunk = array.slice(i, i + chunkSize);
    result.push(_chunk);
  }
  return result;
};

export { arrayDelete, arrayPush, chunk, defaultSortComparator, lookup };
